import { Box, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment-timezone';
import React from 'react';
import { Link } from 'react-router-dom';
import { IReadingChallenge } from '../../services/types';
import { RouteNames } from '../config';
import useStyles from './styles';

interface IProps {
  readingChallenges: IReadingChallenge[] | undefined;
  onClickRow: (readingChallenge: IReadingChallenge) => void;
  onClickDeleteButton: (readingChallenge: IReadingChallenge) => void;
}

const ReadingChallengeList = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { readingChallenges } = props;

  if (readingChallenges && readingChallenges.length === 0) {
    return (
      <Paper>
        <Box display="flex" justifyContent="center" alignItems="center" className={classes.noDataBox} flexDirection="column">
          <Typography>No data</Typography>
          <Typography variant="caption">{'Tap the "Create Reading Challenge" at the top to create a first reading challenge.'}</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center">Title</TableCell>
            <TableCell align="center">Description</TableCell>
            <TableCell align="center">Segment Id</TableCell>
            <TableCell align="center">Story</TableCell>
            <TableCell align="center">Reward Number</TableCell>
            <TableCell align="center">Start At</TableCell>
            <TableCell align="center">End At</TableCell>
            <TableCell align="center">Story Summary</TableCell>
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {readingChallenges &&
            readingChallenges.map(rc => (
              <TableRow
                key={rc.id}
                component={Link}
                to={`${RouteNames.ReadingChallenge}/v/${rc.id}`}
                hover
                onClick={() => {
                  if (!rc.id) {
                    return;
                  }

                  props.onClickRow(rc);
                }}
              >
                <TableCell align="center">{rc.id}</TableCell>
                <TableCell align="center">
                  <Typography noWrap className={classes.tableCell}>
                    {rc.internalTitle}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography noWrap className={classes.tableCell}>
                    {rc.internalDescription}
                  </Typography>
                </TableCell>
                <TableCell align="center">{rc.segmentId}</TableCell>
                <TableCell>
                  <Typography noWrap className={classes.tableCell}>
                    {`${rc.story.title} ( ${rc.story.id} ) `}
                  </Typography>
                </TableCell>
                <TableCell align="center">{rc.rewardNum}</TableCell>
                <TableCell align="center">{rc.startAt && moment(rc.startAt).format('llll')}</TableCell>
                <TableCell align="center">{rc.endAt && moment(rc.endAt).format('llll')}</TableCell>
                <TableCell align="center">
                  <Typography noWrap className={classes.tableCell}>
                    {rc.storySummary}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Tooltip title={''} placement="left-end">
                    <IconButton
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onClickDeleteButton(rc);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ReadingChallengeList;
